import SearchLink from './SearchLink.jsx';

export default SearchLink;
